<template>
  <div v-if="$conFun.clientWidth() > 768">
    <Nav isActive="7" :isIndex="isIndex" />
    <div class="about_s1">
      <div class="pageWD p100">
        <div
          class="f36 cter"
          style="color: #333; padding: 40px 0 10px 0; font-weight: 700"
        >
          云学介绍
        </div>
        <div class="f30 cter" style="color: #8b8b8b">
          云学科技——数智营销服务专家
        </div>
        <div class="flex-sb" style="width: 1070px; margin: 46px auto 0 auto">
          <img
            src="http://h5.shihua.com/static/yunxue/llogo.png"
            style="width: 295px; height: 92px"
          />
          <div
            style="
              width: 1070px;
              margin: 0 0 0 68px;
              text-align: left;
              font-size: 20px;
              color: #656565;
              line-height: 31px;
              font-weight: 700;
            "
          >
            云学科技（北京）有限公司成立于2015年，中国创新数智化营销解决方案服务机构，高新技术企业，数智化营销创新者。云学科技致力于为企业提供数智营销服务，提供覆盖公域私域，线上线下的全场景数智化营销平台，通过数智化改造，代运营服务，助力企业转型升级。
          </div>
        </div>
        <!-- <div style="width: 910px; margin: 0 auto">
          <video
            src="https://yunxue-bucket.oss-cn-shanghai.aliyuncs.com/shcms/video/%E6%9D%9C%E9%95%BF%E6%98%A5.mp4"
            controls="controls"
            class="videocss"
            poster="http://h5.shihua.com/static/yunxue/c1.png"
            style="width: 100%"
          ></video>
        </div> -->
      </div>
    </div>
    <div class="pb100">
      <div class="pageWD">
        <img
          src="http://h5.shihua.com/static/yunxue/ppgs.png"
          style="width: 160px; margin-bottom: 20px"
        />
      </div>
      <div style="background: #f9fcfe">
        <div class="pageWD">
          <div
            style="
              font-size: 24px;
              color: #25a2dd;
              text-align: center;
              padding: 40px 0 20px 0;
            "
          >
            9年数智化营销经验，一直在创新
          </div>

          <div style="text-align: center; width: 960px; margin: 0 auto">
            <div
              style="
                font-size: 16px;
                color: #656565;
                text-align: center;
                padding-bottom: 30px;
              "
            >
              云学科技沉淀9年数智化营销经验，，整合内容营销，数字会议营销，销售线索营销等系列服务，帮助教育，服装，医药，工业，零售等行业领先客户高效获客，实现营销增长。
            </div>
            <img
              src="http://h5.shihua.com/static/yunxue/pic2.png"
              style="width: 960px"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pageWD pb100">
      <img
        src="http://h5.shihua.com/static/yunxue/yxcsr.png?v=1"
        style="width: 200px; margin-bottom: 50px"
      />
      <div class="flex-sb" style="width: 1000px; margin: 0 auto">
        <img
          src="http://h5.shihua.com/static/yunxue/pic1.png"
          style="width: 408px; height: 481px"
        />
        <div style="padding-left: 44px">
          <div class="jnm">姜岚昕</div>
          <div class="f16">
            <div style="margin-bottom: 12px">东方战略管理专家</div>
            <div style="margin-bottom: 12px">社会企业家导师</div>
            <div style="margin-bottom: 12px">北京华夏管理学院</div>
            <div style="margin-bottom: 12px">
              世华教育科技集团 创始人 董事长
            </div>
            <div style="margin-bottom: 12px">
              全球社会企业家生态论坛 创始主席
            </div>
          </div>
          <div class="ctt">
            2001年创办世华公司，专注管理教育领域20余年。他曾出版《增
            长新思维》、《掌控权》、《社会企业家精神》、《领导解放，企
            业重生》、《文化要软，制度要硬》等十余部著作，累计发行量超
            过300万册，影响人群超过上千万。他也是新浪微博、今日头条百
            万级粉丝的大V，他持续笔耕不缀的贡献管理智慧，每年为更多求
            知的人带来受益。
          </div>
        </div>
      </div>
    </div>
    <Fotter />
  </div>

  <div v-else>
    <Nav />
    <div class="mbpage">
      <div class="about_s1" style="padding:0 20px">
        <div>
          <div
            class="f24 cter"
            style="color: #333; padding: 40px 0 10px 0; font-weight: 700"
          >
            云学介绍
          </div>
          <div class="f16 cter" style="color: #8b8b8b">
            云学科技——数智营销服务专家
          </div>
          <div style="margin: 46px auto 0 auto">
            <img
              src="http://h5.shihua.com/static/yunxue/llogo.png"
              style="width: 200px;margin:0 auto"
            />
            <div
              style="
                text-align: left;
                font-size: 14px;
                color: #656565;
                line-height:25px;
                font-weight: 700;
              "
            >
              云学科技（北京）有限公司成立于2015年，中国创新数智化营销解决方案服务机构，高新技术企业，数智化营销创新者。云学科技致力于为企业提供数智营销服务，提供覆盖公域私域，线上线下的全场景数智化营销平台，通过数智化改造，代运营服务，助力企业转型升级。
            </div>
          </div>
        </div>
      </div>
      <div  style="padding:0 20px">
        <div class="">
          <img
            src="http://h5.shihua.com/static/yunxue/ppgs.png"
            style="width: 130px; margin-top: 20px"
          />
        </div>
        <div style="background: #f9fcfe">
          <div>
            <div
              style="
                font-size: 24px;
                color: #25a2dd;
                text-align: center;
                padding: 40px 0 20px 0;
              "
            >
              9年数智化营销经验，一直在创新
            </div>

            <div style="text-align: center; margin: 0 auto">
              <div
                style="
                  font-size: 16px;
                  color: #656565;
                  text-align: center;
                  padding-bottom: 30px;
                "
              >
                云学科技沉淀9年数智化营销经验，，整合内容营销，数字会议营销，销售线索营销等系列服务，帮助教育，服装，医药，工业，零售等行业领先客户高效获客，实现营销增长。
              </div>
              <img src="http://h5.shihua.com/static/yunxue/pic2.png" style="width:100%" />
            </div>
          </div>
        </div>
      </div>
      <div  style="padding:0 20px">
        <img
          src="http://h5.shihua.com/static/yunxue/yxcsr.png?v=1"
          style="width: 140px; margin-bottom: 50px"
        />
        <div style="margin: 0 auto">
          <img
            src="http://h5.shihua.com/static/yunxue/pic1.png"
            style="width: 408px; height: 481px"
          />
          <div style="">
            <div class="jnm">姜岚昕</div>
            <div class="f16">
              <div style="margin-bottom: 12px">东方战略管理专家</div>
              <div style="margin-bottom: 12px">社会企业家导师</div>
              <div style="margin-bottom: 12px">北京华夏管理学院</div>
              <div style="margin-bottom: 12px">
                世华教育科技集团 创始人 董事长
              </div>
              <div style="margin-bottom: 12px">
                全球社会企业家生态论坛 创始主席
              </div>
            </div>
            <div style="border:1px solid #eee;padding:20px">
              2001年创办世华公司，专注管理教育领域20余年。他曾出版《增
              长新思维》、《掌控权》、《社会企业家精神》、《领导解放，企
              业重生》、《文化要软，制度要硬》等十余部著作，累计发行量超
              过300万册，影响人群超过上千万。他也是新浪微博、今日头条百
              万级粉丝的大V，他持续笔耕不缀的贡献管理智慧，每年为更多求
              知的人带来受益。
            </div>
          </div>
        </div>
      </div>
    </div>
    <Fotter />
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Fotter from "@/components/Fotter.vue";
export default {
  name: "bmtd",
  components: { Nav, Fotter },
  data() {
    return {
      vlist: [
        {
          hide: false,
          isrc: "http://h5.shihua.com/static/yunxue/c1.png",
          src: "https://yunxue-bucket.oss-cn-shanghai.aliyuncs.com/shcms/video/%E6%9D%9C%E9%95%BF%E6%98%A5.mp4",
        },
      ],
    };
  },
};
</script>
<style scoped>
.about_s1 {
  background: url("http://h5.shihua.com/static/yunxue/about_bg.png") repeat-x;
}
.jnm {
  font-size: 36px;
  color: #333;
  font-weight: 800;
  position: relative;
  padding-bottom: 40px;
  padding-top: 40px;
}
.jnm:after {
  content: "";
  position: absolute;
  bottom: 20px;
  width: 54px;
  height: 6px;
  background: #25a2dd;
  left: 0;
}
.ctt {
  background: url("http://h5.shihua.com/static/yunxue/picbg.png") no-repeat;
  width: 553px;
  height: 195px;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  padding: 25px 40px;
  position: relative;
  left: -15px;
}
</style>


// WEBPACK FOOTER //
// src/views/about/index.vue